var map = {
	"./collection": 2,
	"./collection.js": 2,
	"./index": 1,
	"./index.js": 1,
	"./utils": 4,
	"./utils.js": 4
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;



/*****************
 ** WEBPACK FOOTER
 ** ./src ^\.\/.*$
 ** module id = 3
 ** module chunks = 0
 **/